module.exports = __webpack_public_path__ + "static/img/IMG_20160308_130609.5c129494.jpg";